import styles from './MarkupIcons.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faMessage, faMicrochip, faPalette, faParagraph, faQuestion, faScrewdriverWrench, faSquareBinary, faTag, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { cx } from '../../classes/Utils';
import { Filter } from './SearchableList';

const makeIcon = (icon: IconDefinition) => <FontAwesomeIcon icon={icon} className={styles.icon} />

const unknownIcon = faQuestion;

const icons: { [key: string]: IconDefinition } = {
    'entry-point': faMicrochip,
    'override': faScrewdriverWrench,
    'comment': faMessage,
    'pointer': faArrowRight,
    'label': faTag,
    'data': faSquareBinary,
    'formatting': faParagraph,
    'graphic': faPalette
}

const iconStyles: { [key: string]: string } = {
    'entry-point': styles.entrypoint,
    'override': styles.override,
    'comment': styles.comment,
    'pointer': styles.pointer,
    'label': styles.label,
    'data': styles.data,
    'formatting': styles.formatting,
    'graphic': styles.graphic
}

export const commandIcon = (name: string) => {

    const icon = icons[name] ?? unknownIcon;
    const iconStyle = iconStyles[name] ?? styles.unknown;

    return <span className={cx(styles.active, styles.surround, iconStyle)}>{makeIcon(icon)}</span>;
}

export const commandTypeToggle = (filter: Filter, i: number) => {
    const icon = icons[filter.name] ?? unknownIcon;
    const iconStyle = iconStyles[filter.name] ?? styles.unknown;
    const activeStyle = filter.isActive ? styles.active : styles.inactive;

    return (
        <button key={i} onClick={e => filter.toggle(e.nativeEvent.shiftKey)} className={cx(activeStyle, styles.button, styles.surround, iconStyle)} >
            {makeIcon(icon)}
            <span className={styles.label}>{filter.label}</span>
        </button>
    )
}